import KeyIcon from '@bv/components/icons/KeyIcon.vue';
import { defineAsyncComponent } from 'vue';

import HistoryIcon from '@/assets/icons/HistoryIcon.vue';
import SimIcon from '@/assets/icons/SimIcon.vue';

import type { ModuleLink, RouteRecordRaw } from '@bv/router';

export const modules: ModuleLink[] = [
  {
    icon: SimIcon,
    title: 'numbers.numbers_trans',
    moduleName: 'numbers-cloud-lines',
    route: { name: 'numbers' },
  },
  {
    icon: KeyIcon,
    title: 'authentications.authentications_trans',
    moduleName: 'credentials-cloud-lines',
    route: { name: 'authentications' },
  },
  {
    icon: HistoryIcon,
    title: 'history.history_trans',
    moduleName: 'cdr-cloud-lines',
    route: { name: 'call-history' },
  },
];

const CloudLinesBalance = defineAsyncComponent(() => import('@/components/header/CloudLinesBalance.vue'));

export const mainRoute: RouteRecordRaw = {
  path: '',
  name: 'main',
  redirect: { name: 'numbers' },
  meta: {
    prependHeaderActions: CloudLinesBalance,
    headerActions: [{ type: 'append', component: CloudLinesBalance }],
  },
  children: [
    {
      path: 'numbers',
      name: 'numbers',
      component: defineAsyncComponent(() => import('@/components/numbers/NumbersList.vue')),
      meta: {
        header: {
          title: 'numbers.my_numbers_trans',
          icon: SimIcon,
        },
        breadcrumbs: [
          {
            label: 'numbers.numbers_trans',
            route: { name: 'numbers' },
          },
        ],
      },
    },
    {
      path: 'authentications',
      name: 'authentications',
      component: defineAsyncComponent(() => import('@/components/authentications/AuthenticationsList.vue')),
      meta: {
        header: {
          title: 'authentications.authentications_title_trans',
          icon: KeyIcon,
        },
        breadcrumbs: [
          {
            label: 'authentications.authentications_trans',
            route: { name: 'authentications' },
          },
        ],
      },
    },
    {
      path: 'call-history',
      name: 'call-history',
      component: defineAsyncComponent(() => import('@/components/call-history/CallHistory.vue')),
      meta: {
        header: {
          title: 'history.call_history_trans',
          icon: HistoryIcon,
        },
        breadcrumbs: [
          {
            label: 'history.history_trans',
            route: { name: 'call-history' },
          },
        ],
      },
    },
  ],
};
